module.exports = __webpack_public_path__ + "img/satellite1.580d06c2.png";